import { render, staticRenderFns } from "./ProductNG1.vue?vue&type=template&id=3a58469a&scoped=true&"
import script from "./ProductNG1.vue?vue&type=script&lang=js&"
export * from "./ProductNG1.vue?vue&type=script&lang=js&"
import style0 from "./ProductNG1.vue?vue&type=style&index=0&id=3a58469a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a58469a",
  null
  
)

export default component.exports